<template>
	<div>
		<!-- <v-dialog v-model="dialog_loading" v-if="dialog_loading" persistent max-width="290"> -->
		<dialog ref="ref_nativeDialog" class="native_dialog" style="min-width: 280px;" v-if="dialog_loading">
	      <v-card>
	        <v-card-text class="pb-4">
	          	{{message}} <span v-if="value">{{ value }}%</span>
				<v-progress-linear color="primary" class="mb-0" v-model="value" :buffer-value="100" buffer v-if="value"></v-progress-linear>
				<v-progress-linear indeterminate color="primary" class="mb-0" v-else></v-progress-linear>
				<!-- <v-progress-linear indeterminate class="mt-2 mb-2" v-if="!$root.uploadStatus || $root.uploadStatus==100"></v-progress-linear> -->
	        </v-card-text>
	        <v-card-actions v-if="!hideCancel">
	        	<v-spacer></v-spacer>
	        	<v-btn color="blue darken-1" flat @click="fn_close">cancel</v-btn>
		    </v-card-actions>
	      </v-card>
		</dialog>
	    <!-- </v-dialog> -->
	</div>
</template>

<script>

export default{
	props:['message', 'closeDialog', 'hideCancel', 'value'],
	data(){
		return{
			dialog_loading:false
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_loading = true;
			setTimeout(() => {
				this.$refs['ref_nativeDialog'].showModal();
			}, 100);
		},
		closeDialogWeb: function () {
			this.$refs['ref_nativeDialog'] ? this.$refs['ref_nativeDialog'].close() : '';
			this.dialog_loading = false;
		},
		fn_close: function(){
			if(this.closeDialog){
				this.closeDialog();
			}
			else{
				this.closeDialogWeb();
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_loading.vue